import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: '1',
    alignItems: 'center',
    margin: theme.spacing(0, 2),
    zIndex: '3',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      paddingBottom: 0,
      margin: 0,
    },
    [theme.breakpoints.up('md')]: {
      paddingBottom: theme.spacing(33),
    },
    '& .content': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  content: {
    [theme.breakpoints.down('md')]: {
      width: 'calc(100% - 12px)',
    },
    [theme.breakpoints.up('md')]: {
      width: 1000,
    },
  },
  wide: {
    [theme.breakpoints.up('xl')]: {
      width: 1400,
    },
  },
  iframe: {
    paddingBottom: 0,
  },
}))
